import { batteryPricingBundle } from "./battery-pricing-bundle"
import { PricingAddersStep } from "../../ProposalSetup/pricing/PricingAddersStep"

export const AddersStep = ({
  proposalId,
  onClose,
}: {
  proposalId: string
  onClose: () => void
}): JSX.Element => (
  <PricingAddersStep
    kind={batteryPricingBundle}
    proposalId={proposalId}
    onClose={onClose}
  />
)
